import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BuyerStrategyResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { strategy } = location.state || {};
  const [showLeadForm, setShowLeadForm] = useState(true);
  const [leadData, setLeadData] = useState({ name: '', mobile: '', email: '' });

  if (!strategy) {
    navigate('/buyer-strategy');
    return null;
  }

  const handleLeadSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/buyer-strategy-leads`, {
        ...leadData,
        strategy_id: strategy.id
      });
      alert(`Thank you ${leadData.name}! Your personalized strategy is ready.`);
      setShowLeadForm(false);
    } catch (error) {
      console.error("Lead error:", error);
      alert("Error submitting. Please try again.");
    }
  };

  if (showLeadForm) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-brand-50 to-white flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full">
          <h2 className="text-2xl font-bold text-center mb-6">Get Your Strategy Report</h2>
          <form onSubmit={handleLeadSubmit} className="space-y-4">
            <input
              type="text"
              placeholder="Your Name"
              value={leadData.name}
              onChange={(e) => setLeadData({...leadData, name: e.target.value})}
              required
              className="w-full p-3 border-2 border-gray-300 rounded-lg"
            />
            <input
              type="email"
              placeholder="Email"
              value={leadData.email}
              onChange={(e) => setLeadData({...leadData, email: e.target.value})}
              required
              className="w-full p-3 border-2 border-gray-300 rounded-lg"
            />
            <input
              type="tel"
              placeholder="Mobile Number"
              value={leadData.mobile}
              onChange={(e) => setLeadData({...leadData, mobile: e.target.value})}
              required
              className="w-full p-3 border-2 border-gray-300 rounded-lg"
            />
            <button
              type="submit"
              className="w-full py-3 bg-brand-500 text-white rounded-lg font-semibold hover:bg-brand-600"
            >
              View My Strategy
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-50 to-white py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-bold text-center text-brand-500 mb-8">
            🏠 Your Personalized Property Strategy
          </h1>

          <div className="space-y-6">
            <div className="bg-brand-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-4">🎯 Recommended Strategy</h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-600">Configuration</p>
                  <p className="font-bold text-lg">{strategy.recommended_configuration}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Property Type</p>
                  <p className="font-bold text-lg">{strategy.recommended_type}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Entry Stage</p>
                  <p className="font-bold text-lg">{strategy.entry_stage}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Holding Period</p>
                  <p className="font-bold text-lg">{strategy.holding_period}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Target ROI</p>
                  <p className="font-bold text-lg text-brand-500">{strategy.target_roi}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Rental Yield</p>
                  <p className="font-bold text-lg">{strategy.rental_yield}</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">📍 Top Recommended Areas</h3>
              <div className="space-y-2">
                {strategy.top_areas.map((area, i) => (
                  <div key={i} className="p-4 bg-gray-50 rounded-lg">
                    {area}
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">⚠️ Risk Management Advice</h3>
              <ul className="space-y-2">
                {strategy.risk_management_advice.map((advice, i) => (
                  <li key={i} className="flex items-start">
                    <span className="text-brand-500 mr-2">✓</span>
                    <span>{advice}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-bold mb-4">📋 Detailed Strategy</h3>
              <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {strategy.detailed_strategy}
              </p>
            </div>

            <div className="bg-gradient-to-r from-brand-500 to-brand-700 text-white p-6 rounded-lg text-center">
              <h3 className="text-2xl font-bold mb-2">Ready to Find Your Perfect Property?</h3>
              <p className="mb-4">Get top 3 matched properties based on your strategy</p>
              <button
                onClick={() => navigate('/contact')}
                className="bg-white text-brand-500 px-8 py-3 rounded-lg font-bold hover:bg-gray-100"
              >
                Talk to Our Expert →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ==================== SCROLL TO TOP ON ROUTE CHANGE ====================

export default BuyerStrategyResultPage;
